// TanStack Query hook pro textové předpovědi CHMI (/api/forecast).
// Natáhne všechny tři kategorie (ČR/Kraje/Hory) najednou — objem dat je malý
// (viz cw-server/doc/plans/forecast-download.md), filtrování na kategorii/region
// se dělá na klientovi z už načtených dat, žádný re-fetch při přepínání.
import { useQuery } from '@tanstack/react-query'
import { api } from '../api/client'

export function useForecastCategories() {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['forecast-all'],
    queryFn: () => api.get('/forecast'),
    staleTime: 5 * 60_000,
  })
  return { data, isLoading, isError }
}
